import { Component } from '@angular/core';

import { ModalService } from '@app/core/services/modal.service';
import { ConfigureService } from '@app/configure/services/configure.service';

import { Modal } from '@app/core/models/modal.model';
import { ModalAction } from '@app/core/models/modal-action.model';

@Component({
	selector: 'cng-soft-error-modal',
	templateUrl: './soft-error.component.html',
})
export class ConfigureSoftErrorModalComponent {
	data: any;

	constructor(private modal_service: ModalService, private configure_service: ConfigureService) {
		this.constructModal();
	}

	constructModal(): void {
		this.data = this.modal_service.data;

		this.modal_service.setConfig(
			new Modal({
				name: 'soft_error_modal',
				title: this.data.soft_error.title,
				actions: [
					new ModalAction({
						id: 'arrange_callback',
						name: 'Arrange Callback',
						large: true,
						click: () => {
							this.modal_service.show(['configure/callback']);
						},
					}),
				],
			})
		);

		this.configure_service.track('modal.open', { modal: 'soft-error' }).subscribe();
	}
}
